import React, { useState } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import authApi from "../api/authApi";

const Login = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: "",
    schoolcode: "",
    password: "",
  });
  //const [schematype, setSchemaType] = useState({schoolcode: "", type: ""});
  const [show, setShow] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Credenstials =>", credentials);
    try {
      const result = await authApi.login(
        credentials.username,
        credentials.schoolcode,
        credentials.password
      );
      if (result.success) {
        // sessionStorage.setItem("token", result.authToken);
        let data = await authApi.fetchMyImage();
        console.log("data2333", data);
        if (data)
          sessionStorage.setItem("myimage", window.URL.createObjectURL(data));
        else
          sessionStorage.setItem(
            "myimage",
            "https://www.w3schools.com/howto/img_avatar.png"
          );
        navigate("/home");
      } else {
        setShow(true);
        setErrorMessage(result.errors);
      }
    } catch (error) {
      console.log("error=>", error);
    }
  };

  const handleChange = (e) => {
    if(e.target.name === 'schoolcode'){
      setCredentials({ ...credentials, [e.target.name]: e.target.value.toLowerCase() });
    }else{
      setCredentials({ ...credentials, [e.target.name]: e.target.value });
    }
    
  };

  const handleSchema = (e) => {
    console.log("Button Value =>", e.target.value);
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const dashboardRedirect = () => {
    // authApi.logout();
    navigate("/");
  };

  console.log("schema type values-->", credentials);
  //console.log('user type values-->', schematype);
  return (
    <Container>
      <Row className="login-form p-3 mt-5">
        <Col lg={6}>
          <b>
            <center>{/* <h1>Digital School Product</h1> */}</center>
          </b>
          <img
            src="/loginBannerParentStudent.jpg"
            style={{ display: "flex", alignItems: "center", marginTop: "50px" }}
          />
        </Col>
        <Col lg={6} className="login-section">
          <h3 className="text-center mb-2"></h3>
          <Row className="p-5">
            <Form onSubmit={handleSubmit}>
              <Row className="mb-2">
                <h3 className="text-center mb-2">
                  {" "}
                  <img
                    src="/comonLogoSchool.png"
                    style={{ width: "auto", height: "12.5rem" }}
                  />
                </h3>
              </Row>
              <Alert variant="danger" show={show}>
                {errorMessage}
              </Alert>
              <Form.Group className="mb-3" controlId="formBasicusername">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  name="username"
                  onChange={handleChange}
                  placeholder="Enter username"
                  required
                  value={credentials.username}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>School Code</Form.Label>
                <Form.Control
                  type="schoolcode"
                  name="schoolcode"
                  onChange={handleChange}
                  placeholder="Enter school code"
                  required
                  value={credentials.schoolcode}
                />
              </Form.Group>

              {/* </Row> */}

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  onChange={handleChange}
                  placeholder="Password"
                  required
                  value={credentials.password}
                />
              </Form.Group>

              <Button variant="success" type="submit" style={{ width: "100%" }}>
                Login
              </Button>

              <center className="mt-3">
                <strong>
                  <Link
                    to="/forget-password"
                    style={{ textDecoration: "none" }}
                  >
                    Forgot Password
                  </Link>
                </strong>
              </center>
            </Form>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
